import React from "react";
import { Download } from "lucide-react";
import { mediaUrl } from "../lib/api";

export default function DownloadPoster({ post, admin = false }) {
  if (!admin) return null;
  const published = Boolean(post?.published_at && !post?.is_draft && !post?.is_private && !post?.is_deleted);
  if (!post || !published) return null;
  const posters = post.posters || {};
  const ready = posters.status === "ready" && posters.portrait;
  const href = (path) => mediaUrl(path);

  return (
    <div className="xs-poster-tools" data-testid={admin ? "admin-download-poster" : "download-poster"}>
      <div className="xs-poster-actions">
        {ready ? <a
          className={`xs-btn ${ready ? "primary" : "ghost"}`}
          href={href(posters.portrait)}
          download={`${post.slug}-poster-1080x1920.png`}
        >
          <Download size={16} aria-hidden="true" />
          Download Poster
        </a> : <span className="xs-poster-unavailable">Poster not available</span>}
        {ready && posters.square && (
          <a className="xs-poster-square" href={href(posters.square)} download={`${post.slug}-poster-1080x1080.png`}>
            Square
          </a>
        )}
      </div>
      <div className="xs-poster-info">{ready ? "Download this post to share on other social media websites" : "Poster not available"}</div>
      {admin && ready && (
        <div className="xs-poster-preview">
          <img src={href(posters.portrait)} alt="Poster preview" />
          <div>
            <strong>{post.title}</strong>
            <div className="xs-poster-url">{window.location.origin}/articles/{post.slug}</div>
          </div>
        </div>
      )}
    </div>
  );
}
